/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Sorts_AlphabeticalInputs */

const id_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abjad`)
};

const ms_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abjad`)
};

const da_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetisk`)
};

const de_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alphabetisch`)
};

const en_us2_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alphabetical`)
};

const es_es2_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabético`)
};

const es_mx2_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabético`)
};

const fil_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpabetikal`)
};

const fr_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alphabétique`)
};

const it_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetico`)
};

const hu_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ábécé sorrend`)
};

const nl_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetisch`)
};

const no_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetisk`)
};

const pl_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetycznie`)
};

const pt_br2_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabético`)
};

const pt_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabético`)
};

const ro_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetic`)
};

const fi_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aakkosjärjestys`)
};

const sv_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetisk`)
};

const vi_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng chữ cái`)
};

const tr_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetik`)
};

const cs_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abecedně`)
};

const bg_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По азбучен ред`)
};

const ru_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По алфавиту`)
};

const uk_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За алфавітом`)
};

const ar_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أبجدي`)
};

const hi_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्णमाला`)
};

const th_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตามตัวอักษร`)
};

const ja_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アルファベット順`)
};

const zh_cn2_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按字母排序`)
};

const zh_hant1_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按字母排序`)
};

const ko_profile_library_sorts_alphabetical = /** @type {(inputs: Profile_Library_Sorts_AlphabeticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알파벳순`)
};

/**
* | output |
* | --- |
* | "Alphabetical" |
*
* @param {Profile_Library_Sorts_AlphabeticalInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_sorts_alphabetical = /** @type {((inputs?: Profile_Library_Sorts_AlphabeticalInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Sorts_AlphabeticalInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_sorts_alphabetical(inputs)
	if (locale === "ms") return ms_profile_library_sorts_alphabetical(inputs)
	if (locale === "da") return da_profile_library_sorts_alphabetical(inputs)
	if (locale === "de") return de_profile_library_sorts_alphabetical(inputs)
	if (locale === "en-US") return en_us2_profile_library_sorts_alphabetical(inputs)
	if (locale === "es-ES") return es_es2_profile_library_sorts_alphabetical(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_sorts_alphabetical(inputs)
	if (locale === "fil") return fil_profile_library_sorts_alphabetical(inputs)
	if (locale === "fr") return fr_profile_library_sorts_alphabetical(inputs)
	if (locale === "it") return it_profile_library_sorts_alphabetical(inputs)
	if (locale === "hu") return hu_profile_library_sorts_alphabetical(inputs)
	if (locale === "nl") return nl_profile_library_sorts_alphabetical(inputs)
	if (locale === "no") return no_profile_library_sorts_alphabetical(inputs)
	if (locale === "pl") return pl_profile_library_sorts_alphabetical(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_sorts_alphabetical(inputs)
	if (locale === "pt") return pt_profile_library_sorts_alphabetical(inputs)
	if (locale === "ro") return ro_profile_library_sorts_alphabetical(inputs)
	if (locale === "fi") return fi_profile_library_sorts_alphabetical(inputs)
	if (locale === "sv") return sv_profile_library_sorts_alphabetical(inputs)
	if (locale === "vi") return vi_profile_library_sorts_alphabetical(inputs)
	if (locale === "tr") return tr_profile_library_sorts_alphabetical(inputs)
	if (locale === "cs") return cs_profile_library_sorts_alphabetical(inputs)
	if (locale === "bg") return bg_profile_library_sorts_alphabetical(inputs)
	if (locale === "ru") return ru_profile_library_sorts_alphabetical(inputs)
	if (locale === "uk") return uk_profile_library_sorts_alphabetical(inputs)
	if (locale === "ar") return ar_profile_library_sorts_alphabetical(inputs)
	if (locale === "hi") return hi_profile_library_sorts_alphabetical(inputs)
	if (locale === "th") return th_profile_library_sorts_alphabetical(inputs)
	if (locale === "ja") return ja_profile_library_sorts_alphabetical(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_sorts_alphabetical(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_sorts_alphabetical(inputs)
	return ko_profile_library_sorts_alphabetical(inputs)
});
export { profile_library_sorts_alphabetical as "profile.library.sorts.alphabetical" }